import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";

interface RoleTabsProps {
  onRoleChange?: (role: string) => void;
}

const RoleTabs: React.FC<RoleTabsProps> = ({ onRoleChange }) => {
  const [activeTab, setActiveTab] = useState(2);

  const tabs = [
    { label: "Admin", value: 0 },
    { label: "Patient", value: 1 },
    { label: "Doctor", value: 2 },
  ];

  const handleTabClick = (tabValue: number) => {
    setActiveTab(tabValue);
    const roles = ["admin", "patient", "doctor"];
    onRoleChange?.(roles[tabValue]);
  };

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#F6F6F6",
        borderRadius: "100px",
        width: "100%",
        height: "40px",
        border: "1px solid #E8E8E9",
        overflow: "hidden",
      }}
    >
      {tabs.map((tab, index) => (
        <Box
          key={tab.value}
          onClick={() => handleTabClick(tab.value)}
          sx={{
            cursor: "pointer",
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor:
              activeTab === tab.value ? "#FFFFFF" : "transparent",
            borderRight: index < tabs.length - 1 ? "1px solid #E8E8E9" : "none",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: activeTab === tab.value ? "#FFFFFF" : "#EFEFEF",
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              fontFamily: "Inter, sans-serif",
              fontWeight: 500,
              letterSpacing: "0.1px",
              color: activeTab === tab.value ? "#000080" : "#1B1B22",
            }}
          >
            {tab.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

RoleTabs.propTypes = {
  onRoleChange: PropTypes.func,
};

export default RoleTabs;
